import { registerActivity } from "../registry";
import { WorkflowActivityDefinition } from "../types";

export const Test: WorkflowActivityDefinition = {
  group: 'internal',
  name: 'test',
  type: 'activity',
  isFlowControl: true,
  schema: {
    type: 'object',
  },
  defaults: {},
  inputs: [
    {
      type: 'flowControl',
      name: 'inFlow',
    },
    {
      type: 'number',
      name: 'input_1',
    },
    {
      type: 'any',
      name: 'input_2',
    },
  ],
  outputs: [
    {
      type: 'flowControl',
      name: 'outFlow',
    },
    {
      type: 'number',
      name: 'result',
    },
  ],
};

registerActivity(Test);
